import { gql } from "@apollo/client/core";

export const USER_LOGIN_QUERY = gql`
  mutation authenticate($input: String!) {
    authenticate(input: $input)
      @rest(
        type: "AuthResponse"
        path: "/api/gtw/v2/auth/login"
        method: "POST"
        bodyKey: "input"
      ) {
      success
      token
      user
      msg
    }
  }
`;

export const LATEST_OTP_QUERY = gql`
  mutation getLatestOtp($input: String!) {
    getLatestOtp(input: $input)
      @rest(
        type: "LatestOtpResponse"
        path: "/greenfield/latestOtp"
        method: "POST"
        bodyKey: "input"
      ) {
      success
      attempts
      expiredTime
      otpCode
    }
  }
`;

export const FIELD_VIST_QUERY = gql`
  query GetDeviceVitals($schoolId: Int!) {
    getDeviceVitals(schoolId: $schoolId) {
      tabVitals {
        records {
          timestamp
          teacherId
          appVersion
          buildNumber
          deviceId
          triggeredFrom
          totalResources
          redResources
          teacherTotalResources
          teacherRedResources
          contentPersistenceRunAt
          oneClickRunAt
          canManageExternalStorage
          developerOptionEnabled
          wifiName
          sdCardSerialNumber
          sdCardVersion
          preparedDate
          isNasEnabled
          isTechBookEnabled
          mdmDeviceId
          totalExternalStorage
          availableExternalStorage
          availableInternalStorage
          availableBattery
          role
          deviceType
          schoolId
          nasIpLastConnected
          lastTimestamp
          realmSize
          teacherMobile
          tabModel
          tabDeliveryDate
          inWarranty
          lastNasIp
          actions
          groupId
          locked
          enrolledTime
          fcmToken
          name
          accessTill
          userId
          status
          roleId
          roleName
          sdCardErrorMessage
          systemBuildVersion
          subjectUpdatedAt
          classUpdatedAt
          studentUpdatedAt
          academicYear
          contextAppNamespace
          tabsetup_by
          preferredUnitsRedResourceCount
          preferredUnitsAmberResourceCount
          preferredUnitsGreenResourceCount
        }
        count
      }
      tvVitals {
        records {
          mdmDeviceId
          groupId
          enrolledTime
          locked
        }
        count
      }
    }
  }
`;

export const NAS_STATUS_QUERY = gql`
  query GetNasStatus($schoolId: Int!) {
    getNasStatus(schoolId: $schoolId) {
      id
      aikaanId
      simRouter
      status
      contentDownloaded
      ip
      internetSpeed
      downloaderVersion
      lastSeen
      updatedAt
      s3_count
      aikaanstatus
    }
  }
`;

export const ACTIVITIES_DATA_QUERY = gql`
  query GetActivities($mobile: String!, $page: Int, $limit:Int, $deviceId: String) {
    getActivities(mobile: $mobile, page: $page, limit: $limit, deviceId: $deviceId) {
      deviceId
      mobile
      schoolId
      teacherId
      received
      timestamp
      app
      wifi
      ip
      timeTook
      hasNas
      details
      event
      total_entries
    }
  }
`;

export const ACTIVITIES_DATA_CAST_QUERY = gql`
  query GetActivitiesCast($mobile: String!, $page: Int, $limit:Int, $deviceId: String, $is_casting: String) {
    getActivitiesCast(mobile: $mobile, page: $page, limit: $limit, deviceId: $deviceId, is_casting: $is_casting) {
      deviceId
      mobile
      timestamp
      app
      details
      event
      properties_is_casting_on
      received
      total_entries
    }
  }
`;

export const ACTIVITIES_DATA_SDCARD_QUERY = gql`
  query GetActivitiesSdcard($mobile: String!, $page: Int, $limit:Int, $deviceId: String) {
    getActivitiesSdcard(mobile: $mobile, page: $page, limit: $limit, deviceId: $deviceId) {
      data {
        deviceId
        mobile
        timestamp
        app
        details
        event
        properties_is_casting_on
        received
      }
      total_entries
    }
  }
`;

export const MOBILE_SEARCH_DATA_QUERY = gql`
  query GetDeviceVitals($mobile: String!) {
    getDeviceVitals(teacherMobile: $mobile) {
      tabVitals {
        records {
          timestamp
          teacherId
          appVersion
          buildNumber
          deviceId
          triggeredFrom
          totalResources
          redResources
          teacherTotalResources
          teacherRedResources
          contentPersistenceRunAt
          oneClickRunAt
          canManageExternalStorage
          developerOptionEnabled
          wifiName
          sdCardSerialNumber
          sdCardVersion
          preparedDate
          isNasEnabled
          isTechBookEnabled
          mdmDeviceId
          totalExternalStorage
          availableExternalStorage
          availableInternalStorage
          availableBattery
          role
          deviceType
          schoolId
          nasIpLastConnected
          lastTimestamp
          realmSize
          teacherMobile
          tabModel
          tabDeliveryDate
          inWarranty
          lastNasIp
          actions
          groupId
          locked
          enrolledTime
          fcmToken
          name
          accessTill
          userId
          status
          roleId
          roleName
          sdCardErrorMessage
          systemBuildVersion
          academicYear
          contextAppNamespace
          tabsetup_by
          preferredUnitsRedResourceCount
          preferredUnitsAmberResourceCount
          preferredUnitsGreenResourceCount

        }
        count
      }
      tvVitals {
        records {
          mdmDeviceId
          groupId
          enrolledTime
          locked
        }
        count
      }
    }
  }
`;

export const SCHOOL_ENROLLMENT_QUERY = (schoolId) => gql`
  mutation schoolEnrollment() {
    schoolEnrollment(){
      status
      group
    }
  }
`;